import React from 'react';

import Slider from '@material-ui/lab/Slider';

import { withMediaProps } from 'react-media-player';

class SeekBar extends React.Component {
  _isPlayingOnMouseDown = false;
  _onChangeUsed = false;

  shouldComponentUpdate({ media }) {
    return (
      isFinite(this.props.media.currentTime) &&
      (this.props.media.currentTime !== media.currentTime ||
        this.props.media.duration !== media.duration)
    );
  }

  _handleMouseDown = () => {
    this._isPlayingOnMouseDown = this.props.media.isPlaying;
    this.props.media.pause();
  };

  _handleMouseUp = (event, value) => {
    // seek on mouseUp as well because of this bug in <= IE11
    // https://github.com/facebook/react/issues/554
    if (value) {
      if (!this._onChangeUsed) {
        this.props.media.seekTo(+value);
      }

      // only play if media was playing prior to mouseDown
      if (this._isPlayingOnMouseDown) {
        this.props.media.play();
      }
    }
  };

  _handleChange = (event, value) => {
    if (value) {
      this.props.media.seekTo(+value);
      this._onChangeUsed = true;
    }
  };

  render() {
    const { media } = this.props;
    const { duration, currentTime } = media;
    return (
      <Slider
        value={currentTime}
        max={Math.round(duration * 1e4) / 1e4}
        onChange={this._handleChange}
        onDragEnd={this._handleMouseUp}
        onDragStart={this._handleMouseDown}
      />
    );
  }
}

export default withMediaProps(SeekBar);
